function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.1,
  height: 20.483,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "home-24px",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_249",
  "data-name": "Trazado 249",
  d: "M0,0H31.5V31.5H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Repetir_cuadr\\xEDcula_1",
  "data-name": "Repetir cuadr\\xEDcula 1",
  transform: "translate(4.203 5.017)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.203 -5.017)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_250",
  "data-name": "Trazado 250",
  d: "M11.839,22.6V16.449H16.86V22.6a1.246,1.246,0,0,0,1.255,1.23h3.766a1.246,1.246,0,0,0,1.255-1.23V13.989h2.134a.608.608,0,0,0,.414-1.07l-10.5-9.26a1.285,1.285,0,0,0-1.682,0l-10.5,9.26a.611.611,0,0,0,.414,1.07H5.561V22.6a1.246,1.246,0,0,0,1.255,1.23h3.766A1.246,1.246,0,0,0,11.839,22.6Z",
  transform: "translate(1.401 1.672)",
  fill: "#dde8f1"
}))));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.859b19ef.svg";
export { ForwardRef as ReactComponent };